import React, { Component } from 'react';
import Wrapper              from './../components/Wrapper';
import Banner               from '../components/containers/BannerContainer';
import StrapLine            from './../containers/StrapLineContainer';
import Filter               from '../components/containers/FilterContainer';
import PlaceList            from './../containers/PlaceListContainer';
import Footer               from '../components/containers/FooterContainer';
import ToggleView           from './../containers/SwitchViewContainer'


class Places extends Component {
    render() {
        return (
            <div>
                <Banner />
                <Wrapper outerClass="body">
                    <StrapLine />
                </Wrapper>
                <Wrapper outerClass="filters" innerClass="menu">
                    <Filter />
                </Wrapper>
                <Wrapper injectTop={ <div className="toggle-view"><ToggleView /></div> }>
                    <PlaceList />
                </Wrapper>
                <Wrapper outerClass="footer">
                    <Footer />
                </Wrapper>
            </div>
        );
    }
}

export default Places;


// WEBPACK FOOTER //
// ./src/pages/Places.js